import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ActionBtn = ({
  /* Navigation & Behavior */
  link = "#!",
  target = "_self",
  isExternal = false,
  isDownload = false,
  fileName = "",
  pdfUrl = "",
  onClick = null,

  /* Appearance & Content */
  title = "Get Started",
  variant = 1,      // numeric style variant (replaces the old "type")
  size = "normal",

  /* NEW: Submit Behavior */
  isSubmit = false, // if true, renders a real <button type="submit">

}) => {

  // 1. Define style configurations
  let fontSize, paddingSize;
  switch (size) {
    case 'normal':
      fontSize = ' text__16 ';
      paddingSize = ' px-3 md:!px-4 py-[0.6rem] md:!py-3 ';
      break;
    case 'small':
      fontSize = ' text__12 ';
      paddingSize = ' px-2 md:!px-3 py-1 md:!py-2 ';
      break;
    default:
      fontSize = ' text__16 ';
      paddingSize = ' px-3 md:!px-4 py-[0.6rem] md:!py-3 ';
  }

  // 2. Download functionality
  const handleDownload = () => {
    fetch(pdfUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const linkElement = document.createElement("a");
        linkElement.href = url;
        linkElement.download = fileName;
        document.body.appendChild(linkElement);
        linkElement.click();
        document.body.removeChild(linkElement);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("File download error:", error);
        // Optionally show a user-friendly message here
      });
  };

  // 3. General click handler
  const handleClick = (e) => {
    if (isDownload) {
      // Prevent navigation, handle file download
      e.preventDefault();
      handleDownload();
    } else if (onClick) {
      // Prevent default only if there's a custom onClick
      e.preventDefault();
      onClick(e);
    }
  };

  // 4. Build CSS classes
  const buttonClass = `
    inline-block rounded-full transition-all duration-300 arrowWrap 
    ${paddingSize}
    ${
    variant === 1 
      ? "bg-black hover:bg-black/90" 
      : variant === 2 
      ? "bg-Mneutral50 hover:bg-Mbrand400" 
      : variant === 3 
      ? "bg-orange-500 hover:bg-orange-600" // New orange variant
      : "bg-Mneutral50 hover:bg-Mbrand400"
  }
  `;

  const textClass = `
    font-semibold ${fontSize}
    ${variant === 1 || variant === 3 ? "text-white" : "text-Mbaseblack"} // White text for orange variant
  `;

  // 5. Decide what to render

  // A) Real submit button for forms
  if (isSubmit) {
    return (
      <button
        type="submit" 
        // If you want to allow a custom onClick in addition to form submission:
        onClick={onClick ? handleClick : null}
        className={buttonClass}
      >
        <div className="flex items-center gap-3">
          <p className={textClass}>{title}</p>
        </div>
      </button>
    );
  }

  // B) External link
  if (isExternal) {
    return (
      <a
        href={link}
        target={target}
        rel="noopener noreferrer"
        className={buttonClass}
      >
        <div className="flex items-center gap-3">
          <p className={textClass}>{title}</p>
        </div>
      </a>
    );
  }

  // C) Download or custom onClick (non-form scenario)
  if (isDownload || onClick) {
    return (
      <a 
        href={link} 
        onClick={handleClick} 
        className={buttonClass}
      >
        <div className="flex items-center gap-3">
          <p className={textClass}>{title}</p>
        </div>
      </a>
    );
  }

  // D) Internal navigation (react-router-dom)
  return (
    <Link 
      to={link} 
      target={target} 
      className={buttonClass}
    >
      <div className="flex items-center gap-3">
        <p className={textClass}>{title}</p>
      </div>
    </Link>
  );
};

ActionBtn.propTypes = {
  link: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.number,         // Replaces the old "type" prop
  size: PropTypes.oneOf(["normal", "small"]),
  onClick: PropTypes.func,
  isExternal: PropTypes.bool,
  isDownload: PropTypes.bool,
  fileName: PropTypes.string,
  pdfUrl: PropTypes.string,

  /** NEW: indicates the button is used for form submission */
  isSubmit: PropTypes.bool,
};

export default ActionBtn;

